export default "__VITE_ASSET__xvbf0Kw1__"